import { QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { RouterProvider } from "react-router-dom";
import { queryClient } from "@/lib/queryClient";
import { router } from "@/router";
import { initSentry } from "@/lib/sentry";
import { ThemeProvider } from "@/components/theme/ThemeContext";

initSentry();

export default function App(): JSX.Element {
  return (
    <Sentry.ErrorBoundary
      fallback={() => (
        <div className="mx-auto mt-20 max-w-md p-4">
          <h1 className="mb-2 text-xl font-semibold">This page crashed.</h1>
          <p className="text-sm text-text-secondary dark:text-brand-100/70">
            We logged it. Refresh to recover.
          </p>
        </div>
      )}
    >
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <RouterProvider router={router} />
        </ThemeProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}
